var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPositionsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 902,
    height: 198,
    viewBox: "0 0 902 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M902 3.37701C902 3.37701 759.64 123.536 638.616 122.744C565.602 122.26 504.843 33.62 323.722 4.27226C149.131 -24.0053 0 97.3475 0 97.3475V114.326C0 114.326 162.576 -21.0932 517.135 172.466C600.323 217.887 745.256 197.832 803.983 150.527C864.717 101.608 879.835 73.5668 902 26.0155V3.37701Z",
    fill: "url(#paint0_linear_4316_4444)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.0120291 40.9151C0.0120291 40.9151 199.652 169.303 451.006 85.9128C702.36 2.52234 817.814 34.9079 902 77.0101V186.985C902 186.985 838.524 192.539 649.54 157.485C420.447 114.98 431.956 186.418 229.947 197.557C119.82 203.626 0 145.346 0 145.346V40.9151H0.0120291Z",
    fill: "url(#paint1_linear_4316_4444)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4316_4444",
    x1: 97,
    y1: -68,
    x2: 859.527,
    y2: 675.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#5E88EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00DBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0AD2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#86DBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7DBDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4316_4444",
    x1: 465.173,
    y1: 245.214,
    x2: 447.52,
    y2: -18.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC00FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#EF0BFD",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#CC29F8",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9459F1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#489CE7",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00DBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#86DBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7DBDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPositionsBg);
export default __webpack_public_path__ + "static/media/no-positions-bg.cdbed0e95b540306ed1563b47e4bf2f5.svg";
export { ForwardRef as ReactComponent };